import Option from './option';
import GroupData from './types/group-data';
import A11yConsentApi from './a11y-consent-api';
import AbstractGroup from './abstract-group';
import Logger from './utilities/logger';

/**
 * Default consent option group, meaning it contains consent options which can be enabled or disabled by the user.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export default class Group extends AbstractGroup {
  public options: { [p: string]: Option } = {};

  constructor(api: A11yConsentApi, data: GroupData) {
    super(api, data);
    Logger.debug('group', `Starting to construct "${this.uid}".`);

    for (const identifier in data.options) {
      this.options[identifier] = new Option(this.api, this, data.options[identifier]);
    }

    Logger.debug('group', `Finished constructing "${this.uid}".`);
  }

  /**
   * Enabled or disables all consent options of this group. This will also automatically trigger the decoding of
   * corresponding content.
   *
   * @param {boolean} enabled True to enable all options, otherwise false
   */
  public setOptionsEnabled(enabled: boolean): void {
    for (const identifier in this.options) {
      const option = this.options[identifier];
      option.setEnabled(enabled);
    }
  }

  /**
   * Decodes all consent options of this group.
   */
  public decodeOptions(): void {
    for (const identifier in this.options) {
      const option = this.options[identifier];
      option.decode();
    }
  }
}
